module.exports = __webpack_public_path__ + "img/cszl-1.ccc40c65.png";